import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import LockFilledIcon from '@atlaskit/icon/glyph/lock-filled';
import UnlockIcon from '@atlaskit/icon/glyph/unlock';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { FormattedMessage } from '@atlassian/jira-intl';
import { COMMENT_VISIBILITY_TYPE_PUBLIC } from '@atlassian/jira-issue-view-common-types/src/comment-type';
import messages from './messages';
import type { TargetButtonProps } from './types';

export const buttonMaxWidth = 300; // px

const TargetButton = ({ selectedOption, isSelected }: TargetButtonProps) => {
	const isPublic = selectedOption.type === COMMENT_VISIBILITY_TYPE_PUBLIC;
	const Icon = isPublic ? UnlockIcon : LockFilledIcon;
	const tooltipContent = !isPublic ? (
		<FormattedMessage {...messages.optionsTooltip} values={{ value: selectedOption.value }} />
	) : (
		<FormattedMessage {...messages.publicTooltip} />
	);

	return (
		<ButtonWrapper>
			<Tooltip content={tooltipContent} position="left">
				<Button
					spacing="default"
					isSelected={isSelected}
					shouldFitContainer
					iconBefore={
						<ButtonContent removeIconMargin={!isPublic}>
							<Icon label="" />
						</ButtonContent>
					}
					testId="issue-comment-base.ui.comment.comment-visibility.button"
					interactionName="auto-generated.issue-comment-base.ui.comment.comment-visibility.button.button"
				>
					{!isPublic && <OptionText>{selectedOption.value}</OptionText>}
				</Button>
			</Tooltip>
		</ButtonWrapper>
	);
};

export default TargetButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonContent = styled.div({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	margin: (props: any) =>
		props.removeIconMargin ? `0 ${token('space.negative.050', '-4px')};` : undefined,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const OptionText = styled.div({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '250px',
	marginLeft: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({ maxWidth: `${buttonMaxWidth}px` });
